import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { getTranslations } from '@translations';
import {
  Button,
  Icon,
  Overlay,
  Promo as PromoContent,
  Dropdown,
  DropdownTrigger,
  DropdownLayover,
} from '@components';
import { useGTM } from '@hooks';
import { PromosPropType } from '@propTypes';

import styles from './styles/index.module.scss';

const Promo = ({ isB2B, promos, className, isLoading }) => {
  const translations = getTranslations();

  const [isVisible, setIsVisible] = useState(false);
  const [displaySentToGTM, setDisplaySentToGTM] = useState(false);
  const [pushToGTM] = useGTM();

  const onPromosDisplay = useCallback(() => {
    promos.forEach(promo => {
      pushToGTM({
        event: 'display_campaign',
        campaign_id: promo.campaign_uuid,
        campaign_name: promo.name,
        space_slug: 'onglet_banner',
      });
    });
  }, [promos, pushToGTM]);

  const onPromoClick = useCallback(
    (id, name) => {
      pushToGTM({
        event: 'click_campaign',
        campaign_id: id,
        campaign_name: name,
        space_slug: 'onglet_banner',
      });
    },
    [pushToGTM],
  );

  const onMouseEnter = () => {
    setIsVisible(true);

    if (!displaySentToGTM) {
      onPromosDisplay();
      setDisplaySentToGTM(true);
    }
  };
  const onMouseLeave = () => setIsVisible(false);

  const renderPromoMenu = () => {
    let promoMenu = null;
    if (isLoading) {
      promoMenu = (
        <div className={styles.promoTab}>
          <Icon size="20" id="spinner" />
        </div>
      );
    } else if (promos.length > 0) {
      promoMenu = (
        <Dropdown
          className={styles.dropdown}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <DropdownTrigger>
            <Button
              color="transparent"
              className={styles.promoTab}
              data-qa="selectDealsCta"
            >
              <Icon size="20" id="promo" className={styles.promoIcon} />
              <span className={styles.promoText}>
                {translations('header.subheader.promos.text')}
              </span>
            </Button>
          </DropdownTrigger>
          <DropdownLayover>
            <PromoContent
              isB2B={isB2B}
              promos={promos}
              onPromoClick={onPromoClick}
            />
          </DropdownLayover>
        </Dropdown>
      );
    }

    return promoMenu;
  };

  return (
    <div className={className}>
      {isVisible ? <Overlay /> : null}
      {renderPromoMenu()}
    </div>
  );
};

Promo.propTypes = {
  isB2B: PropTypes.bool.isRequired,
  promos: PromosPropType.isRequired,
  className: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

Promo.defaultProps = {
  className: null,
};

export default Promo;
